export const CUSTOMER_ENVIRONMENT_APPLICATION_SOURCE = {
  InstallationImport: 'InstallationImport',
  WdacImport: 'WdacImport',
};

// The two ways a customer application is created, carrying the app catalog's badge palette so the
// same source reads the same wherever it is drawn.
const CUSTOMER_ENVIRONMENT_APPLICATION_SOURCE_MAPPING = [
  {
    value: CUSTOMER_ENVIRONMENT_APPLICATION_SOURCE.InstallationImport,
    label: 'Installation Import',
    color: '#9EE6C4',
    borderColor: 'rgba(158, 230, 196, 0.4)',
    backgroundColor: 'rgba(62, 118, 105, 0.25)',
  },
  {
    value: CUSTOMER_ENVIRONMENT_APPLICATION_SOURCE.WdacImport,
    label: 'WDAC Import',
    color: '#8EB4FF',
    borderColor: 'rgba(142, 180, 255, 0.4)',
    backgroundColor: 'rgba(48, 91, 173, 0.25)',
  },
];

const find = value =>
  CUSTOMER_ENVIRONMENT_APPLICATION_SOURCE_MAPPING.find(item => item.value === value);

export const getCustomerEnvironmentApplicationSourceLabel = value => find(value)?.label ?? '';

export const getCustomerEnvironmentApplicationSourceColor = value =>
  find(value)?.color ?? '#9CA3AF';

export const getCustomerEnvironmentApplicationSourceBorderColor = value =>
  find(value)?.borderColor ?? 'rgba(156, 163, 175, 0.4)';

export const getCustomerEnvironmentApplicationSourceBackgroundColor = value =>
  find(value)?.backgroundColor ?? 'rgba(90, 90, 90, 0.25)';

export const getCustomerEnvironmentApplicationSourceOptions = () =>
  CUSTOMER_ENVIRONMENT_APPLICATION_SOURCE_MAPPING.map(({ value, label }) => ({ value, label }));
